<template>
  <div
    class="bet-alert"
      :style="{
          'background':`url(../../img/bet/background-${colors.theme}.png), linear-gradient(180deg, ${colors[colors.theme].from} 0%,  ${colors[colors.theme].to} 100%)`,
          'color' : colors.theme == 'dark' ? `#fff` : `#000`
      }"
  >
    <div class="bet-alert-container">
        <div class="bet-alert-image">
            <!-- <img src="/img/bet/coin.png" alt="" class="image-alert"> -->
            <Coin class="image-alert"></Coin>
        </div>
        <div class="desc-first-alert" v-if="index <= 0">
        <div class="desc-first-top">
          <p>
            {{ $t("components.betAlert.desc-first-top.p1") }}
            <span
              class="bet"
              :style="{
                    color: '#000'
                }"
            >{{bet.bet.toLocaleString('pt-br')}} pontos</span>
          </p>
          <p>
            {{ $t("components.betAlert.desc-first-top.p2") }}
            <span
              class="bet"
              :style="{
                    color: '#000'
                }"
            >{{bet.win.toLocaleString('pt-br')}} pontos</span>
          </p>
        </div>
        <div class="desc-first-bottom">
          {{$t("components.betAlert.desc-first-bottom.span1")}}
          <span class="bold">{{$t("components.betAlert.desc-first-bottom.bold1")}}</span>
          {{$t("components.betAlert.desc-first-bottom.span2")}}
          <span class="bold">{{$t("components.betAlert.desc-first-bottom.bold2")}}</span> {{$t("components.betAlert.desc-first-bottom.span3")}}
        </div>
      </div>
      <div class="desc-alert" v-if="index > 0">
        <span class="desc">{{$t("components.betAlert.desc-alert.span1")}}</span>
        <span class="bet">{{bet.bet}} pontos</span>
      </div>
      <div class="bet-alert-buttons">
        <div class="button-container" @click="sendBet()">
          <button-default
            :textButton="$t('components.betAlert.bet-alert-buttons.button-container1')" 
            :style="{background: colors.secondary}"
            buttonType="primary"></button-default>
        </div>
        <div class="button-container" @click="deleteBet()">
          <button-default 
            :style="{
              'color' : colors.theme == 'dark' ? `#000` : `#fff`,
              'background-color' : colors.theme == 'dark' ? `#fff` : `#000`
            }"
            :textButton="$t('components.betAlert.bet-alert-buttons.button-container2')" 
            buttonType="primary"></button-default>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ButtonDefault from "../buttons/ButtonDefault.vue";
import Coin from '../shared/customIcons/betCoin'
export default {
  components: {
    ButtonDefault,Coin
  },
  props: {
    index: {
      type: Number
    },
    bet: {
      type: Object
    }
  },
  data() {
    return {
      colors: {}
    };
  },
  created() {
    this.colors = JSON.parse(localStorage.getItem("colors"));
  },
  methods: {
    sendBet() {
      this.$emit("sendBet");
    },
    deleteBet() {
      this.$emit("deleteBet");
    }
  }
};
</script>
<style lang="scss" scoped>
.bet-alert {
  background-size: cover !important;
  height: 100%;
  display: flex;

  .bet-alert-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    width: 100%;

    .bet-alert-image {
      height: 20%;
      display: flex;
      align-items: flex-end;
      justify-content: center;

      .image-alert {
        width: 120px;
      }
    }

    .desc-alert {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 20%;

      .desc {
        letter-spacing: 2px;
        text-transform: uppercase;
        font-size: 14px;
      }

      .bet {
        font-size: 35px;
        margin-top: 10px;
        font-weight: bold;
      }
    }

    .desc-first-alert {
      width: 80%;
      height: 22%;
      text-align: center;
      letter-spacing: 1px;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .desc-first-top {
        font-size: 15px;
        // color: black;
        line-height: 18px;

        .bet {
          background-color: white;
          padding: 2px 9px;
          margin: 2px;
          // color: #76277d;
          font-weight: bold;
        }
      }

      .desc-first-bottom {
        margin-top: 20px;
        font-size: 12px;
        line-height: 14px;
      }
    }

    .bet-alert-buttons {
      width: 100%;
      height: 35%;

      .button-container {
        width: 60%;
        margin: 5% auto;

        .button-default{
          font-size: 15px;
          letter-spacing: 3px;
          text-transform: uppercase;
          padding: 15px 0;
          height: auto;
          border-radius: 35px;
        }
      }
    }
  }
}

@media only screen and (min-width: 750px) {
  .bet-alert {
    .bet-alert-container {
      .desc-first-alert {
        height: 16%;
        width: 50%;

        .desc-first-top {
          font-size: 15px;

          p {
            line-height: 25px;
          }
        }

        .desc-first-bottom {
          font-size: 12px;
        }
      }

      .bet-alert-buttons {
        // margin-top: 5%;

        .button-container {
          width: 30%;
          margin: 2% auto;
        }
      }
    }
  }
}
</style>
